<template>
  <el-form style="width: 350px;margin: auto" size="small" align="center" status-icon :model="formData" :rules="rules"
           ref="formData"
           label-width="120px">
    <el-form-item prop="versionCode" align="left" label="Version Code">
      <el-input class="el-input--small" :disabled="true" v-model="formData.versionCode"></el-input>
    </el-form-item>
    <el-form-item prop="versionName" align="left" label="Version Name">
      <el-input class="el-input--small" :disabled="true" v-model="formData.versionName"></el-input>
    </el-form-item>
    <el-form-item prop="isForce" align="left" label="Force Update">
      <el-switch v-model="formData.isForce" :active-value='1' :inactive-value='0'></el-switch>
    </el-form-item>
    <el-form-item prop="type" align="left" label="Type">
      <el-select v-model="formData.type" placeholder="please select">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item hidden prop="downloadUrl" align="left" label="Download Link">
      <el-input class="el-input--small" v-model="formData.downloadUrl"></el-input>
    </el-form-item>
    <el-form-item prop="remark" align="left" label="Remark">
      <el-input type="textarea" class="el-input--small" v-model="formData.remark"></el-input>
    </el-form-item>
    <el-form-item align="right">
      <el-button class="el-button--small" @click="goBack">Back</el-button>
      <!--<el-button class="el-button&#45;&#45;small el-button&#45;&#45;warning" @click="$router.push({path:'content'})">Content
      </el-button>-->
      <el-button class="el-button--small el-button--primary" @click="submit('formData')">Save</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    name: 'AppVersionAdd',
    props: {
      closeDialog: Function,
      dialogSucc: Function,
      chooseItem:Object
    },
    data () {
      return {
        formData: {
/*          app_version_id:'',
          versionCode: '',
          versionName: '',
          isForce: '',
          downloadUrl: '',
          remark: '',
          type: ''*/
        },
        rules: {
          versionCode: [{required: true, message: 'please input version code!'}],
          versionName: [{required: true, message: 'please input version name!'}],
          isForce: '',
          downloadUrl: '',
          remark: '',
          type: ''
        },
        options: [{
          value: 'android',
          label: 'android'
        }, {
          value: 'ios',
          label: 'ios'
        }]
      }
    },
    created () {
      this.formData=JSON.parse(JSON.stringify(this.chooseItem))
      console.log(JSON.stringify(this.formData))
    },
    methods: {
      submit (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.formData.type==='ios'){
              this.formData.downloadUrl='https://apps.apple.com/us/app/id1530890498'
            }else {
              this.formData.downloadUrl='https://play.google.com/store/apps/details?id=com.storypod.eddi'
            }
            console.log(JSON.stringify(this.formData))
            let loading=this.$util.loading()
            this.$api.rootV1.post('/web/appversion/editor', this.formData,
              (res) => {
                this.$alert( 'Successfully modified!','info', {
                  confirmButtonText: 'confirm',
                  type:'success',
                  callback: action => {
                    this.$emit("dialogSucc")
                    loading.close()
                  }
                })
              }, (res) => {
                this.$alert( `fail to edit！${res.errmsg}`,'info', {
                  confirmButtonText: 'confirm',
                  type:'error',
                  callback: action => {
                    loading.close()
                  }
                })
                /*                this.$message.error('Add failed,Duplicate Craftie ID!')
                                this.$refs['formData'].fields[2].validateMessage = 'Duplicate Craftie ID!'
                                this.$refs['formData'].fields[2].validateState = 'error'*/
              })
          } else {
            this.$message.warning('Please check the input data!')
          }
        })
      },
      goBack () {
        this.$emit('closeDialog')
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/appVersion/AppVersionEdit.vue